const FIELD_LABELS = {
  subcontractNumber: "Số quyết định giao khoán",
  subcontractName: "Tên quyết định giao khoán",
  contractId: "Hợp đồng chính",
  signDate: "Ngày ký",
  startDate: "Ngày bắt đầu",
  endDate: "Ngày kết thúc",
  startDateAct: "Ngày bắt đầu thực tế",
  endDateAct: "Ngày kết thúc thực tế",
  provinceId: "Tỉnh/thành phố",
  totalValue: "Tổng giá trị quyết định giao khoán",
  vat: "VAT (%)",
  description: "Mô tả",
  status: "Trạng thái",
  currency: "Đơn vị tiền tệ",
  itemDistributionType: "Loại giao khoán",
  assigneeSourceType: "Loại đơn vị thực hiện",
  assigneeSourceId: "Đơn vị thực hiện",
  teamMembers: "Nhân sự tham gia",
  personnelId: "Nhân sự",
  roleInSubcontract: "Vai trò trong giao khoán",
  displayOrder: "Thứ tự hiển thị",
  joinDate: "Ngày tham gia",
  documentType: "Loại tài liệu",
  file: "File đính kèm",
};

const fieldLabel = (path) => {
  const field = path.split(".").pop();
  const label = Object.entries(FIELD_LABELS).find(([key]) => key.toLowerCase() === field.toLowerCase())?.[1];
  const member = path.match(/teamMembers\[(\d+)\]/i);
  if (member) return `Nhân sự thứ ${Number(member[1]) + 1}${label ? ` - ${label}` : ""}`;
  return label || (path === "$" || !path ? "Dữ liệu gửi lên" : path);
};

const text = (value) => typeof value === "string" ? value.trim() : "";

export const SUBCONTRACT_NUMBER_MAX_LENGTH = 50;

export const getSubcontractNumberError = (value) => {
  const length = text(value).length;
  return length > SUBCONTRACT_NUMBER_MAX_LENGTH
    ? `Số quyết định giao khoán chỉ được tối đa ${SUBCONTRACT_NUMBER_MAX_LENGTH} ký tự (hiện có ${length} ký tự). Vui lòng rút gọn nội dung.`
    : "";
};

const formatFieldError = (field, message) => {
  const label = fieldLabel(field);
  // Older API versions use the default English DataAnnotations length message.
  const maxLength = message.match(/^The field \S+ must be a string with a maximum length of (\d+)\.$/);
  if (maxLength) return `${label} chỉ được tối đa ${maxLength[1]} ký tự. Vui lòng rút gọn nội dung.`;
  return message.startsWith(label) ? message : `${label}: ${message}`;
};

export const getSubcontractFormErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const errors = data?.errors ?? data?.Errors;
  if (errors && typeof errors === "object" && !Array.isArray(errors)) {
    const details = Object.entries(errors).flatMap(([field, messages]) =>
      (Array.isArray(messages) ? messages : [messages])
        .map(text)
        .filter(Boolean)
        .map((message) => formatFieldError(field, message)));
    if (details.length) return [...new Set(details)].join("\n");
  }

  const serverMessage = text(data?.message) || text(data?.Message) || text(data?.detail) || text(data?.Detail);
  if (serverMessage) return serverMessage;
  // A plain text response can also contain a business message; ignore HTML error pages.
  if (text(data) && !/[<>]/.test(data)) return text(data);

  switch (error?.response?.status) {
    case 400:
    case 422:
      return "Dữ liệu giao khoán không hợp lệ. Vui lòng kiểm tra thông tin đã nhập.";
    case 401:
      return "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.";
    case 403:
      return "Bạn không có quyền thực hiện thao tác này với giao khoán.";
    case 404:
      return "Không tìm thấy dữ liệu liên quan đến giao khoán. Vui lòng tải lại và kiểm tra.";
    case 409:
      return "Dữ liệu giao khoán bị trùng hoặc đã thay đổi. Vui lòng tải lại và kiểm tra.";
    default:
      if (error?.response) return fallback;
  }
  if (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT") {
    return "Yêu cầu quá thời gian chờ. Vui lòng kiểm tra kết nối và dữ liệu đã lưu trước khi thử lại.";
  }
  if (error?.isAxiosError || error?.code === "ERR_NETWORK") {
    return "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng và thử lại.";
  }
  return text(error?.message) || fallback;
};
